import theme_icons from '../../icons.js';

const { __ } = wp.i18n;
const { registerBlockType } = wp.blocks;
const { InspectorControls, ColorPalette } = wp.blockEditor;
const { PanelBody, SelectControl } = wp.components;
const { useEffect, useState } = wp.element;

const meetourstudents = {
  title: 'Meet Our Students',
  icon: theme_icons.greenheart,
  category: 'greenheart',
  //attributes
  attributes: {
    bgcolor: {
      type: 'string',
      default: '#ffffff'
    },
    context: {
      type: 'string',
      default: ''
    },
    format: {
      type: 'string',
      default: ''
    },
    formPayload: {
      type: 'string',
      default: ''
    },

  },

  edit({ attributes, setAttributes }) {
    const { bgcolor, context, format, formPayload } = attributes;
    const [isLoading, setIsLoading] = useState(false);
    const fetchFormMarkup = async () => {
      setIsLoading(true);
      try {
        const response = await fetch('/wp-json/wp/v2/queries/meet_our_students/form/');
        const formMarkup = await response.json();
        setAttributes({ formPayload: formMarkup.payload });
      } catch (error) {
        console.error('Error fetching form markup:', error);
      } finally {
        setIsLoading(false);
      }
    };

    useEffect(() => {
      fetchFormMarkup();
    }, []);
    function onFormatChange(newformat) {
      setAttributes({ format: newformat });
    }
    function onContextChange(newctx) {
      setAttributes({ context: newctx });
    }

    return ([
      <InspectorControls>
        <PanelBody title={__('Size')}>
          <p>Context (size)</p>
          <SelectControl
            value={context}
            options={[
              { label: 'Inner', value: 'small' },
              { label: 'Full', value: 'large' }
            ]}
            onChange={onContextChange}
          />
          <p>Return Format</p>
          <SelectControl
            value={format}
            options={[
              { label: 'Cards', value: '' },
              { label: 'Index', value: 'index' },
            ]}
            onChange={onFormatChange}
          />
          <p>Background Color</p>
          <ColorPalette
            value={bgcolor}
            onChange={bgcolor => setAttributes({ bgcolor })}
          />

          <p>Manually Refresh Form Filters</p>
          <p>(Due to the nature of this block, if you add new Interests or Countries it doesn't automatically update the form filters. Clicking this button will refresh the form filters.)</p>
          <button onClick={fetchFormMarkup} disabled={isLoading}>
            {isLoading ? 'Refreshing...' : 'Refresh'}
          </button>
        </PanelBody>
      </InspectorControls>,
      <div className="rbt-meetourstudents" key="2" style={{ backgroundColor: bgcolor }}>
        {/* Put placeholder image here */}
        <p>Context: {context}</p>
        <p>Format: {format}</p>
        <img style={{ maxWidth: "300px", border: "1px solid black" }} src="/wp-content/plugins/GreenheartBlockEngineTravel/assets/MOSControls.png" loading="lazy" alt="Placeholder" />
      </div>
    ]);
  },
  save({ attributes }) {
    const { bgcolor, formPayload } = attributes;

    return (
      <div className="rbt-meetourstudents rbt-query" data-handle="meet_our_students" data-process="rbtQuery" style={{ backgroundColor: bgcolor }}>
        <div className="rbt-query-form-wrap" dangerouslySetInnerHTML={{ __html: formPayload }}></div>
        <div className="rbt-query-results-wrap" dangerouslySetInnerHTML={{ __html: '<span class="rbt-loader"><svg version="1.1" id="Layer_1" class="loader" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 53.2 50" style="enable-background:new 0 0 53.2 50;"><style type="text/css">.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#00843D;}.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#FFD100;}</style><g><path class="st0" d="M26.6,8.5C28.5,5.2,30.9,3,34,1.8c1.9-0.8,3.8-1.1,5.5-1c1.9,0.1,4,0.3,6,1.3c2.1,1.1,3.6,2.8,4.7,4.5 c1.1,1.6,1.8,3.6,2.1,6.1c0.3,2.5,0.1,4.6-0.5,6.5c-0.6,1.8-1.4,3.5-2.4,5.1c-0.9,1.6-2.2,3.1-3.7,4.7c-0.9,0.9-2.4,2.3-4.4,4.1 c-0.9,0.8-2.4,2.1-4.5,3.9c-1.8,1.5-3.1,2.7-4,3.5c-2.4,2.2-4.5,4.7-6.3,7.4c-1.7-2.7-3.8-5.2-6.2-7.4c-0.9-0.8-2.2-2-4-3.5 c-1.5-1.3-3-2.6-4.4-3.9c-2-1.8-3.5-3.2-4.4-4.1c-1.5-1.5-2.8-3.1-3.7-4.7c-1-1.6-1.8-3.3-2.4-5.1c-0.6-1.8-0.8-4-0.5-6.5 c0.3-2.5,1-4.5,2.1-6.1c1.1-1.6,2.2-3,4.4-4.1c2-1,4.4-1.6,6.3-1.7c1.8-0.1,3.6,0.3,5.5,1C22.3,3,24.8,5.2,26.6,8.5"/><path class="st1" d="M14.2,1.6c-0.2,0-0.3,0-0.5,0c-1.9,0.1-4.2,0.7-6,1.6c-1.9,1-3,2.2-4.1,3.8c-1,1.5-1.7,3.4-1.9,5.8 c-0.3,2.3-0.1,4.4,0.5,6.1c0.6,1.7,1.4,3.4,2.3,5c0.9,1.5,2.1,3.1,3.6,4.5c0.8,0.9,2.2,2.2,4.4,4.1c0.9,0.8,2.3,2.1,4.4,3.8 c1.8,1.5,3.1,2.7,4,3.5c2.1,2,4.1,4.2,5.7,6.6c1.7-2.4,3.6-4.6,5.7-6.6c0.9-0.9,2.3-2.1,4-3.5c1.5-1.3,3-2.5,4.4-3.8 c1.9-1.7,3.4-3.1,4.4-4.1c1.5-1.5,2.7-3.1,3.6-4.5c0.9-1.6,1.7-3.2,2.3-5c0.6-1.7,0.8-3.8,0.5-6.1c-0.3-2.4-0.9-4.3-1.9-5.8 c-1.3-2-2.8-3.3-4.4-4.2c-1.8-1-3.8-1.2-5.6-1.2c-0.1,0-0.3,0-0.5,0c-1.6,0-3.2,0.3-4.8,1c-2.9,1.1-5.3,3.3-7,6.4l-0.7,1.2 l-0.7-1.2c-1.8-3.1-4.1-5.2-7-6.4C17.3,1.9,15.7,1.6,14.2,1.6z M26.6,49.3l-0.7-1c-1.7-2.7-3.8-5.1-6.1-7.3c-0.9-0.8-2.2-2-4-3.5 c-1.5-1.3-3-2.6-4.5-3.9c-2.2-1.9-3.6-3.2-4.5-4.1c-1.5-1.6-2.8-3.2-3.8-4.8c-1-1.7-1.8-3.4-2.4-5.3c-0.7-2-0.9-4.2-0.6-6.8 c0.3-2.6,1-4.8,2.2-6.5C3.5,4.4,4.8,3,7,1.8c1.9-1,4.5-1.7,6.6-1.8c1.9-0.1,3.9,0.3,5.9,1c2.9,1.1,5.3,3.1,7.1,5.9 c1.8-2.8,4.2-4.8,7.1-5.9c2-0.8,3.9-1.1,5.9-1.1c2,0.1,4.2,0.3,6.3,1.4c1.9,1,3.5,2.5,5,4.7c1.2,1.7,1.9,3.9,2.2,6.5 c0.3,2.6,0.1,4.9-0.6,6.8c-0.7,1.9-1.5,3.6-2.4,5.3c-0.9,1.6-2.2,3.2-3.8,4.8c-1,1-2.5,2.4-4.5,4.1c-1,0.9-2.5,2.2-4.5,3.9 c-1.7,1.4-3,2.6-4,3.5c-2.4,2.2-4.4,4.6-6.1,7.3L26.6,49.3L26.6,49.3z"/> </g></svg></span>' }}>
        </div>
      </div>
    );
  }
};
registerBlockType('rbt/meetourstudents', meetourstudents);
export default meetourstudents;
